import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { RestrictionDetailDto, RestrictionsVm } from '../models/restrictions.model';

@Injectable({ providedIn: 'root' })
export class RestrictionsService extends BaseApiService {
  getAllRestrictions(): Observable<RestrictionsVm> {
    // Mapea /restrictions
    return this.get<RestrictionsVm>('/restrictions');
  }

  getRestriction(restrictionCode: string): Observable<RestrictionDetailDto> {
    // Mapea /restrictions/{restrictionCode}
    return this.get<RestrictionDetailDto>(`/restrictions/${restrictionCode}`);
  }
}
